import React, { useState } from 'react';
import { auth, addOfferToFirebase } from '../firebase'; // Firebase imports

const TouristGuideOfferCreate = () => {
  const [offerTitle, setOfferTitle] = useState('');
  const [offerDescription, setOfferDescription] = useState('');
  const [price, setPrice] = useState('');
  const [error, setError] = useState('');

  const handleCreateOffer = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser; // Get the current logged-in user

      if (user) {
        const offerData = {
          offerTitle,
          offerDescription,
          price,
          guideUid: user.uid, // Link the offer to the tourist guide by UID
        };

        // Add the offer to Firestore
        await addOfferToFirebase(offerData);

        alert('تم إنشاء العرض بنجاح!');
        // Redirect or reset the form after successful offer creation
      } else {
        setError('يجب أن تكون مسجلاً الدخول لإنشاء عرض.');
      }
    } catch (error) {
      setError(error.message); // Handle errors
    }
  };

  return (
    <div className="container mx-auto p-8">
      <h2 className="text-3xl font-semibold text-center mb-8">أنشئ عرضك</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleCreateOffer} className="max-w-lg mx-auto space-y-6">
        <div>
          <label className="block text-lg">عنوان العرض</label>
          <input
            type="text"
            value={offerTitle}
            onChange={(e) => setOfferTitle(e.target.value)}
            className="w-full p-4 mt-2 border border-gray-300 rounded-lg"
            required
          />
        </div>
        <div>
          <label className="block text-lg">وصف العرض</label>
          <textarea
            value={offerDescription}
            onChange={(e) => setOfferDescription(e.target.value)}
            className="w-full p-4 mt-2 border border-gray-300 rounded-lg"
            required
          />
        </div>
        <div>
          <label className="block text-lg">السعر</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="w-full p-4 mt-2 border border-gray-300 rounded-lg"
            required
          />
        </div>
        <button type="submit" className="w-full bg-green-500 text-white p-4 rounded-lg">
          إنشاء عرض
        </button>
      </form>
    </div>
  );
};

export default TouristGuideOfferCreate;
